const getAddressFromLocationData = (location) => {
    if (location && location.predictionInfo && location.predictionInfo.description) {
        return location.predictionInfo.description;
    }
    return '';
};

export default getAddressFromLocationData;
